import React from "react";
import { WrapperSeamless } from "layout-components";
import Table from "components/tables/table";
import { useTranslation } from "localization/translation";
import { Button } from "@material-ui/core";
import { ACTIVE, DEACTIVATED } from "Constants";

export const PricingInformation = ({
  prices,
  actionHandler,
}) => {
  const translation = useTranslation();

  const rows = prices?.map((price) => (
    <tr
      key={price.id}
      className={`px-2 py-2 m-2 my-3 font-weight-bold position-relative`}
    >
      <td className="text-left px-3">
        <div className="font-size-sm feature_list_brake">{price.price} {price.currency}</div>
      </td>
      <td className="text-left px-3">
        <div className="font-size-sm feature_list_brake">{price.billing_period} </div>
      </td>
      <td className="text-left px-3">
        <div className="font-size-sm feature_list_brake">{price.active ? ACTIVE : DEACTIVATED} </div>
      </td>
      <td className="text-right px-3">
        <div className="font-size-sm align-box-row">
          <Button
            variant="contained"
            type="button"
            onClick={() => actionHandler(price.id)}
            className="mr-2 button-1"
          >
            {translation.edit}
          </Button>
        </div>
      </td>
    </tr>
  ));

  return (
    <WrapperSeamless>
      <Table
        fields={
          <>
            <th className="text-left px-3">
              <span className="mr-3">{translation.price || 'Price'}</span>
            </th>
            <th className="text-left px-3">
              <span className="mr-3">{translation.billing_period || 'Billing period'}</span>
            </th>
            <th className="text-left px-3">
              <span className="mr-3">{translation.status}</span>
            </th>
            <th className="text-left px-3">
              <span className="mr-3">{translation.action}</span>
            </th>
          </>
        }
        noDrag
        title={translation.prices || 'Prices'}
        items={prices}
        rows={rows}
        actions={false}
        userPage
      />
    </WrapperSeamless>
  );
};
